import { configureStore } from "@reduxjs/toolkit";
import todoReducer from "../features/todoRedux/todo"
import currentLocationReducer from "../features/currentLocationRedux/currentLocation";
import currentLanguageReducer from "../features/currentlanguageRedux/currentLanguage";
import currentProfileReducer from "../features/currentProfileRedux/currentProfile"
import adminAuthenReducer from "../features/adminAuthenRedux/adminAuthen"

const rootReducer = {
  todo: todoReducer,
  currentLocation: currentLocationReducer,
  currentLanguage: currentLanguageReducer,
  currentProfile: currentProfileReducer,
  adminAuthen: adminAuthenReducer,
}
const store = configureStore({
  reducer: rootReducer
})

export default store;